<template>
  <a-modal
    :body-style="bodyStyle"
    :visible="modalVisible"
    @cancel="modalCancel"
    @ok="modalSubmit"
    width="50%"
    cancelText="取消"
    okText="确认"
    :title="!modalType ? '创建任务' : modalType === 1 ? '编辑任务' : '任务详情'"
  >
    <a-form
      ref="formRef"
      :model="form"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
    >
      <a-form-item label="终端" name="taskTerminal">
        <p v-if="modalType === 2">
          <a-badge :text="taskTerminalOps[form.taskTerminal]" />
        </p>
        <a-radio-group
          v-model:value="form.taskTerminal"
          v-else
          @change="changeBrowse"
        >
          <a-radio :value="1">web</a-radio>
          <a-radio :value="2">app</a-radio>
          <a-radio :value="0">all</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="任务分类" name="taskCategory">
        <p v-if="modalType === 2">
          <a-input
            v-model:value="form.taskCategoryName"
            :bordered="modalType !== 2"
          />
        </p>
        <a-select
          v-model:value="form.taskCategory"
          placeholder="请选择"
          show-search
          optionFilterProp="label"
          allow-clear
          v-else
        >
          <a-select-option
            v-for="(item, index) in assortSelect"
            :key="index"
            :value="item['taskCategoryId']"
            :label="item['taskCategoryName']"
          >
            {{ item['taskCategoryName'] }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="任务名称">
        <a-button
          type="dashed"
          block
          @click="addNameContent"
          style="width: 120px;"
        >
          <PlusOutlined />
        </a-button>
      </a-form-item>
      <a-form-item label="说明">
        <a-space
          v-for="(item, index) in form.taskName"
          :key="index"
          style="display: flex; margin-bottom: 8px"
          align="baseline"
        >
          <a-form-item
            :name="['taskName', index, 'key']"
            label="语言"
            :rules="{
              required: true,
              message: '请选择语言'
            }"
          >
            <a-select
              v-model:value="item.key"
              :options="langList"
              placeholder="请选择"
              @change="changeTaskName"
            >
            </a-select>
          </a-form-item>
          <a-form-item
            label="名称"
            :name="['taskName', index, 'value']"
            :rules="{
              required: true,
              message: '请输入名称'
            }"
          >
            <a-textarea
              v-model:value="item.value"
              placeholder="请输入名称"
              auto-size
            />
          </a-form-item>

          <MinusCircleOutlined @click="removeNameContent(item)" />
        </a-space>
      </a-form-item>

      <a-form-item label="任务描述">
        <a-button
          type="dashed"
          block
          @click="addDescContent"
          style="width: 120px;"
        >
          <PlusOutlined />
        </a-button>
      </a-form-item>
      <a-form-item label="说明">
        <a-space
          v-for="(item, index) in form.taskDesc"
          :key="index"
          style="display: flex; margin-bottom: 8px"
          align="baseline"
        >
          <a-form-item
            :name="['taskDesc', index, 'key']"
            label="语言"
            :rules="{
              required: true,
              message: '请选择语言'
            }"
          >
            <a-select
              v-model:value="item.key"
              :options="langList"
              placeholder="请选择"
              @change="changeTaskDesc"
            >
            </a-select>
          </a-form-item>
          <a-form-item
            label="描述"
            :name="['taskDesc', index, 'value']"
            :rules="{
              required: true,
              message: '请输入描述'
            }"
          >
            <a-textarea
              v-model:value="item.value"
              placeholder="请输入描述"
              auto-size
            />
          </a-form-item>

          <MinusCircleOutlined @click="removeDescContent(item)" />
        </a-space>
      </a-form-item>

      <a-form-item label="挽留文案">
        <a-button type="dashed" block @click="addContent" style="width: 120px;">
          <PlusOutlined />
        </a-button>
      </a-form-item>
      <a-form-item label="说明">
        <a-space
          v-for="(item, index) in form.taskRetention"
          :key="index"
          style="display: flex; margin-bottom: 8px"
          align="baseline"
        >
          <a-form-item
            :name="['taskRetention', index, 'key']"
            label="语言"
            :rules="{
              required: true,
              message: '请选择语言'
            }"
          >
            <a-select
              v-model:value="item.key"
              :options="langList"
              placeholder="请选择"
              @change="changeTaskRetention"
            >
            </a-select>
          </a-form-item>
          <a-form-item
            label="文案"
            :name="['taskRetention', index, 'value']"
            :rules="{
              required: true,
              message: '请输入文案'
            }"
          >
            <a-textarea
              v-model:value="item.value"
              placeholder="请输入文案"
              auto-size
            />
          </a-form-item>

          <MinusCircleOutlined @click="removeContent(item)" />
        </a-space>
      </a-form-item>

      <a-form-item label="任务有效期" name="emptyTime">
        <p v-if="modalType === 2">
          {{ form.startTime }}
          ~
          {{ form.endTime }}
        </p>
        <a-range-picker
          v-model:value="form.emptyTime"
          show-time
          :format="'YYYY-MM-DD HH:mm:ss'"
          @change="changeRangePicker"
          :placeholder="['开始时间', '结束时间']"
          v-else
        />
      </a-form-item>

      <a-form-item
        label="web活动ID"
        name="taskActivityId"
        v-if="form.taskTerminal == 0 || form.taskTerminal == 1"
      >
        <p v-if="modalType === 2">
          <a-input
            v-model:value="form.taskActivityId"
            :bordered="modalType !== 2"
          />
        </p>
        <a-input
          v-model:value="form.taskActivityId"
          placeholder="请输入web活动ID"
          style="width: 350px;"
          v-else
        />
      </a-form-item>

      <a-form-item
        label="app活动ID"
        name="taskAppActivityId"
        v-if="form.taskTerminal == 0 || form.taskTerminal == 2"
      >
        <p v-if="modalType === 2">
          <a-input
            v-model:value="form.taskAppActivityId"
            :bordered="modalType !== 2"
          />
        </p>
        <a-input
          v-model:value="form.taskAppActivityId"
          placeholder="请输入app活动ID"
          style="width: 350px;"
          v-else
        />
      </a-form-item>

      <!-- <a-form-item label="任务类型" name="typeId">
        <p v-if="modalType === 2">
          <a-input v-model:value="form.typeName" :bordered="modalType !== 2" />
        </p>
        <a-select
          ref="select"
          v-model:value="form.typeId"
          placeholder="请选择"
          v-else
          @change="changeType"
        >
          <a-select-option :value="1" key="浏览任务">浏览任务</a-select-option>
          <a-select-option :value="2" key="完成事件">完成事件</a-select-option>
        </a-select>
      </a-form-item> -->

      <a-form-item label="目标名称">
        <a-button
          type="dashed"
          block
          @click="addTargetNameContent"
          style="width: 120px;"
        >
          <PlusOutlined />
        </a-button>
      </a-form-item>
      <a-form-item label="说明">
        <a-space
          v-for="(item, index) in form.taskTargetName"
          :key="index"
          style="display: flex; margin-bottom: 8px"
          align="baseline"
        >
          <a-form-item :name="['taskTargetName', index, 'key']" label="语言">
            <a-select
              v-model:value="item.key"
              :options="langList"
              placeholder="请选择"
              @change="changeTaskTargetName"
            >
            </a-select>
          </a-form-item>
          <a-form-item label="名称" :name="['taskTargetName', index, 'value']">
            <a-textarea
              v-model:value="item.value"
              placeholder="请输入名称"
              auto-size
            />
          </a-form-item>

          <MinusCircleOutlined @click="removeTargetNameContent(item)" />
        </a-space>
      </a-form-item>

      <a-form-item label="目标描述">
        <a-button
          type="dashed"
          block
          @click="addTargetDescContent"
          style="width: 120px;"
        >
          <PlusOutlined />
        </a-button>
      </a-form-item>
      <a-form-item label="说明">
        <a-space
          v-for="(item, index) in form.taskTargetDesc"
          :key="index"
          style="display: flex; margin-bottom: 8px"
          align="baseline"
        >
          <a-form-item :name="['taskTargetDesc', index, 'key']" label="语言">
            <a-select
              v-model:value="item.key"
              :options="langList"
              placeholder="请选择"
              @change="changeTaskTargetDesc"
            >
            </a-select>
          </a-form-item>
          <a-form-item label="名称" :name="['taskTargetDesc', index, 'value']">
            <a-textarea
              v-model:value="item.value"
              placeholder="请输入名称"
              auto-size
            />
          </a-form-item>

          <MinusCircleOutlined @click="removeTargetDescContent(item)" />
        </a-space>
      </a-form-item>

      <a-form-item label="目标类型" name="targetType">
        <p v-if="modalType === 2">
          <a-badge :text="typeOps[form.targetType]" />
        </p>
        <a-select
          ref="select"
          v-model:value="form.targetType"
          style="width: 350px;"
          placeholder="请选择"
          @change="changeTargetType"
          v-else
        >
          <a-select-option :value="'1'" key="签到">签到</a-select-option>
          <a-select-option :value="'2'" key="浏览">浏览</a-select-option>
          <a-select-option :value="'3'" key="分享">分享</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="目标行为" name="targetAction">
        <p v-if="modalType === 2">
          <a-badge :text="targetActionOps[form.targetAction]" />
        </p>
        <a-select
          ref="select"
          v-model:value="form.targetAction"
          style="width: 350px;"
          placeholder="请选择"
          v-else
          @change="changeBrowseTwo"
        >
          <a-select-option :value="'1'" key="点击" v-if="form.targetType == '1'"
            >点击</a-select-option
          >
          <a-select-option :value="'2'" key="浏览" v-if="form.targetType == '2'"
            >浏览</a-select-option
          >
          <a-select-option
            :value="'3'"
            key="抽奖助力"
            v-if="form.targetType == '3'"
            >抽奖助力</a-select-option
          >
          <a-select-option
            :value="'4'"
            key="访问页面"
            v-if="form.targetType == '3'"
            >访问页面</a-select-option
          >
        </a-select>
      </a-form-item>

      <a-form-item label="行为次数" name="targetValue">
        <p v-if="modalType === 2">
          <a-input
            v-model:value="form.targetValue"
            :bordered="modalType !== 2"
          />
        </p>
        <a-input-number
          v-model:value="form.targetValue"
          placeholder="请输入"
          min="0"
          style="width: 350px;"
          v-else
        />
      </a-form-item>

      <a-form-item
        label="web任务路径"
        v-if="
          (form.taskTerminal == 1 && form.targetAction == '2') ||
            (form.taskTerminal == 0 && form.targetAction == '2')
        "
        name="targetUrl"
      >
        <p v-if="modalType === 2">
          <a-input v-model:value="form.targetUrl" :bordered="modalType !== 2" />
        </p>
        <a-input
          v-model:value="form.targetUrl"
          placeholder="请输入任务路径"
          style="width: 350px;"
          v-else
        />
      </a-form-item>

      <a-form-item
        label="web任务页面"
        v-if="
          (form.taskTerminal == 1 && form.targetAction !== '1') ||
            (form.taskTerminal == 0 && form.targetAction !== '1') ||
            (form.taskTerminal == 2 && form.targetAction == '3') ||
            (form.taskTerminal == 2 && form.targetAction == '4')
        "
        name="targetPage"
      >
        <p v-if="modalType === 2">
          <a-input
            v-model:value="form.targetPage"
            :bordered="modalType !== 2"
          />
        </p>
        <a-input
          v-model:value="form.targetPage"
          placeholder="请输入任务页面"
          style="width: 350px;"
          v-else
        />
      </a-form-item>

      <a-form-item
        label="app任务路径"
        v-if="
          (form.taskTerminal == 2 && form.targetAction == '2') ||
            (form.taskTerminal == 0 && form.targetAction == '2')
        "
        name="targetAppUrl"
      >
        <p v-if="modalType === 2">
          <a-input
            v-model:value="form.targetAppUrl"
            :bordered="modalType !== 2"
          />
        </p>
        <a-input
          v-model:value="form.targetAppUrl"
          placeholder="请输入任务路径"
          style="width: 350px;"
          v-else
        />
      </a-form-item>

      <a-form-item
        label="app任务页面"
        v-if="
          (form.taskTerminal == 2 && form.targetAction !== '1') ||
            (form.taskTerminal == 0 && form.targetAction !== '1') ||
            (form.taskTerminal == 1 && form.targetAction == '3') ||
            (form.taskTerminal == 1 && form.targetAction == '4')
        "
        name="targetAppPage"
      >
        <p v-if="modalType === 2">
          <a-input
            v-model:value="form.targetAppPage"
            :bordered="modalType !== 2"
          />
        </p>
        <a-input
          v-model:value="form.targetAppPage"
          placeholder="请输入任务页面"
          style="width: 350px;"
          v-else
        />
      </a-form-item>

      <!-- <a-form-item label="活动ID" name="activityId">
        <p v-if="modalType === 2">
          <a-input
            v-model:value="form.activityId"
            :bordered="modalType !== 2"
          />
        </p>
        <a-input
          v-model:value="form.activityId"
          placeholder="请输入活动ID"
          style="width: 350px;"
          v-else
        />
      </a-form-item> -->

      <a-form-item label="任务完成类型" name="finishType">
        <p v-if="modalType === 2">
          <a-badge :text="finishTypeOps[form.finishType]" />
        </p>
        <a-radio-group
          v-model:value="form.finishType"
          @change="selectFinishType"
          v-else
        >
          <a-radio :value="0">一次性任务</a-radio>
          <a-radio :value="1">每日任务</a-radio>
        </a-radio-group>
      </a-form-item>

      <a-form-item label="可完成次数" name="finishCountLimit">
        <p v-if="modalType === 2">
          <a-input
            v-model:value="form.finishCountLimit"
            :bordered="modalType !== 2"
          />
        </p>
        <a-input-number
          v-model:value="form.finishCountLimit"
          placeholder="请输入"
          min="0"
          style="width: 300px;"
          v-else
        />
      </a-form-item>

      <a-form-item
        label="完成时间"
        name="finishEmptyTime"
        v-if="form.finishType == 1"
      >
        <p v-if="modalType === 2">
          {{ form.finishStartTime }}
          ~
          {{ form.finishEndTime }}
        </p>
        <a-range-picker
          v-model:value="form.finishEmptyTime"
          show-time
          :format="'YYYY-MM-DD'"
          @change="changeFinishRangePicker"
          :placeholder="['开始时间', '结束时间']"
          v-else
        />
      </a-form-item>

      <!-- <div v-if="form.eventTypeId == 2">
        <a-form-item label="助力次数" v-if="form.typeId == 2" required>
          <p v-if="modalType === 2">
            <a-input
              v-model:value="form.completionNumber"
              :bordered="modalType !== 2"
            />
          </p>
          <a-input-number
            v-model:value="form.completionNumber"
            placeholder="请输入助力次数"
            min="1"
            style="width: 350px;"
            v-else
          />
        </a-form-item>
      </div>
      <div v-else>
        <a-form-item label="完成次数" v-if="form.typeId == 2" required>
          <p v-if="modalType === 2">
            <a-input
              v-model:value="form.completionNumber"
              :bordered="modalType !== 2"
            />
          </p>
          <a-input-number
            v-model:value="form.completionNumber"
            placeholder="请输入完成次数"
            min="1"
            style="width: 350px;"
            v-else
          />
        </a-form-item>
      </div> -->
      <!-- <a-form-item label="限制时间" v-if="form.typeId == 2" required>
        <p v-if="modalType === 2">
          <a-input v-model:value="form.limitTime" :bordered="modalType !== 2" />
        </p>
        <a-input-group compact v-else>
          <a-input-number
            v-model:value="form.limitTime"
            placeholder="请输入"
            :min="1"
            :precision="0"
            :formatter="transformNum"
            :parser="transformNum"
            style="width: 30%"
            oninput="if (value < 0) value = 0"
          />
          <a-select
            v-model:value="form.limitTimeUnit"
            style="width: 16%"
            @change="changeDate"
          >
            <a-select-option :value="1">小时</a-select-option>
            <a-select-option :value="2" v-model="selected">
              天
            </a-select-option>
          </a-select>
        </a-input-group>
      </a-form-item> -->

      <a-form-item label="奖励名称">
        <a-button
          type="dashed"
          block
          @click="addRewardNameContent"
          style="width: 120px;"
        >
          <PlusOutlined />
        </a-button>
      </a-form-item>
      <a-form-item label="说明">
        <a-space
          v-for="(item, index) in form.taskRewardName"
          :key="index"
          style="display: flex; margin-bottom: 8px"
          align="baseline"
        >
          <a-form-item :name="['taskRewardName', index, 'key']" label="语言">
            <a-select
              v-model:value="item.key"
              :options="langList"
              placeholder="请选择"
              @change="changeTaskRewardName"
            >
            </a-select>
          </a-form-item>
          <a-form-item label="名称" :name="['taskRewardName', index, 'value']">
            <a-textarea
              v-model:value="item.value"
              placeholder="请输入名称"
              auto-size
            />
          </a-form-item>

          <MinusCircleOutlined @click="removeRewardNameContent(item)" />
        </a-space>
      </a-form-item>

      <a-form-item label="奖励描述">
        <a-button
          type="dashed"
          block
          @click="addRewardDescContent"
          style="width: 120px;"
        >
          <PlusOutlined />
        </a-button>
      </a-form-item>
      <a-form-item label="说明">
        <a-space
          v-for="(item, index) in form.taskRewardDesc"
          :key="index"
          style="display: flex; margin-bottom: 8px"
          align="baseline"
        >
          <a-form-item :name="['taskRewardDesc', index, 'key']" label="语言">
            <a-select
              v-model:value="item.key"
              :options="langList"
              placeholder="请选择"
              @change="changeTaskRewardDesc"
            >
            </a-select>
          </a-form-item>
          <a-form-item label="名称" :name="['taskRewardDesc', index, 'value']">
            <a-textarea
              v-model:value="item.value"
              placeholder="请输入名称"
              auto-size
            />
          </a-form-item>

          <MinusCircleOutlined @click="removeRewardDescContent(item)" />
        </a-space>
      </a-form-item>

      <a-form-item label="奖励类型" name="rewardType">
        <p v-if="modalType === 2">
          <a-badge :text="unitOps[form.rewardType]" />
        </p>
        <a-radio-group
          v-model:value="form.rewardType"
          @change="selectType"
          v-else
        >
          <a-radio :value="'1'">积分</a-radio>
          <a-radio :value="'2'">抽奖次数</a-radio>
          <a-radio :value="'3'">优惠券</a-radio>
        </a-radio-group>
      </a-form-item>

      <a-form-item
        label="奖励值"
        name="rewardValue"
        v-if="form.rewardType == '1'"
        required
      >
        <p v-if="modalType === 2">
          <a-input
            v-model:value="form.rewardValue"
            :bordered="modalType !== 2"
          />
        </p>
        <a-input
          v-model:value="form.rewardValue"
          placeholder="请输入场景id"
          style="width: 300px;"
          v-else
        />
      </a-form-item>

      <a-form-item
        label="奖励值"
        name="rewardValue"
        v-if="form.rewardType == '2'"
        required
      >
        <p v-if="modalType === 2">
          <a-input
            v-model:value="form.rewardValue"
            :bordered="modalType !== 2"
          />
        </p>
        <a-input
          v-model:value="form.rewardValue"
          placeholder="请输入活动id"
          style="width: 300px;"
          v-else
        />
      </a-form-item>

      <a-form-item
        label="奖励值"
        name="rewardValue"
        v-if="form.rewardType == '3'"
        required
      >
        <p v-if="modalType === 2">
          <a-input
            v-model:value="form.rewardValue"
            :bordered="modalType !== 2"
          />
        </p>
        <a-input
          v-model:value="form.rewardValue"
          placeholder="请输入规则ID"
          style="width: 300px;"
          v-else
        />
      </a-form-item>

      <!-- <a-form-item label="限制条件" name="restrictions">
        <p v-if="modalType === 2">
          <span>
            单用户活动期间
            {{ form.day }}
            天只能参与
            {{ form.number }}
            次
          </span>
        </p>
        <div v-else>
          <span>单用户活动期间</span>
          <a-input-number
            v-model:value="form.day"
            placeholder="请输入"
            min="1"
            style="margin-left: 1%;"
          ></a-input-number>
          <span style="margin-left: 1%;">天只能参与</span>
          <a-input-number
            v-model:value="form.number"
            placeholder="请输入"
            min="1"
            style="margin-left: 1%;"
          ></a-input-number>
          <span style="margin-left: 1%;">次</span>
        </div>
      </a-form-item> -->

      <a-form-item label="奖励数量" name="rewardCount">
        <p v-if="modalType === 2">
          <a-input
            v-model:value="form.rewardCount"
            :bordered="modalType !== 2"
          />
        </p>
        <a-input-number
          v-model:value="form.rewardCount"
          placeholder="请输入"
          min="0"
          style="width: 300px;"
          v-else
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { inject, toRefs } from 'vue'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons-vue'
export default {
  components: {
    PlusOutlined,
    MinusCircleOutlined
  },
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  color: #000;
}
.item {
  text-align: center;
  border: 1px solid #dedede;
  .label {
    padding: 10px 15px;
    white-space: nowrap;
  }
  .value {
    height: 100%;
    white-space: nowrap;
    padding: 10px 15px;
    border-top: 1px solid #dedede;
    .ant-form-item {
      margin: 0;
    }
  }
}
</style>
